// extracted by mini-css-extract-plugin
export default {"alert__container":"Alert_alert__container__y+CoX"};